<ng-container *ngIf="isReadOnly; else showRadioButton">
  <div sigvValueDiffItem="contractFormat" class="p-text-bold-500">
    {{
      bindingFormControl?.value ?? bindingFormControl?.getRawValue()
        | replaceNullWith : '-'
        | optionsMapping : selectOptions
    }}
  </div>
</ng-container>
<ng-template #showRadioButton>
  <div *ngIf="isVertical; else horizontalLayout">
    <!-- Vertical Layout -->
    <div class="flex flex-column">
      <sigv-form-control-widget
        [fieldName]="fieldName"
        [bindingFormControl]="bindingFormControl"
      >
        <div
          *ngFor="let selectOption of selectOptions"
          class="flex align-items-center justify-content-start p-mb-2"
        >
          <p-radioButton
            *ngIf="!selectOption.disabled"
            [formControl]="bindingFormControl"
            [label]="selectOption.label | replaceNullWith : '-' | translate"
            [value]="selectOption.value"
            class="p-mr-2 p-field-radiobutton"
            (onClick)="onClickEvent($event, selectOption.value)"
            (onFocus)="focused.emit($event)"
            (onBlur)="blurred.emit($event)"
          ></p-radioButton>
        </div>
      </sigv-form-control-widget>
    </div>
  </div>
</ng-template>

<ng-template #horizontalLayout>
  <!-- Horizontal Layout -->
  <div class="d-flex flex-wrap align-items-center">
    <sigv-form-control-widget
      [fieldName]="fieldName"
      [bindingFormControl]="bindingFormControl"
    >
      <ng-container *ngFor="let selectOption of selectOptions">
        <p-radioButton
          *ngIf="!selectOption.disabled"
          [formControl]="bindingFormControl"
          [label]="selectOption.label | replaceNullWith : '-' | translate"
          [value]="selectOption.value"
          class="p-mr-2 p-mb-2"
          (onClick)="onClickEvent($event, selectOption.value)"
          (onFocus)="focused.emit($event)"
          (onBlur)="blurred.emit($event)"
        ></p-radioButton>
      </ng-container>
    </sigv-form-control-widget>
  </div>
</ng-template>
